import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'
import { previewWebfleetBorders } from './previewWebfleetBorders'
import {
  WebfleetBorderPreviewRequest,
  WebfleetBorderPreviewResponse,
} from './types'

export function useMutationPreviewWebfleetBorders(companyId: string) {
  return useMutation<
    AxiosResponse<WebfleetBorderPreviewResponse>,
    Error,
    WebfleetBorderPreviewRequest
  >({
    mutationFn: (payload) => previewWebfleetBorders({ companyId, payload }),
  })
}
